<template>
    <div class="card-list">
        <slotCard :icon="'attach_money'" :type="'oneLine'" :isLoading="isLoading">
          <span class="font-weight-bold">200 EUR</span>
        </slotCard>

        <slotCard class="pt-4" :icon="'query_builder'" :type="'oneLine'" :isLoading="isLoading">
          <span><span class="font-weight-bold">23</span> units in total</span>
        </slotCard>

        <slotCard class="pt-4" :type="'oneLine'" :isLoading="isLoading">
          <span><span class="font-weight-bold">250 km</span> of total distance</span>
        </slotCard>

        <slotCard class="pt-4" :type="'twoLine'" :isLoading="isLoading">
          <span class="block">Total weight is <span class="font-weight-bold">1000kg</span></span>
          <span class="block">Chargable weight is <span class="font-weight-bold">1000kg</span></span>
        </slotCard>

        <slotCard class="pt-4" :icon="'fas fa-truck'" :type="'twoLine'" :isLoading="isLoading">
          <span class="block font-weight-bold">Servis Climax, a.s.</span>
          <span class="block">Joe Doe &#8226; Mercedes Benz Sprinter &#8226; 1AA 1234</span>
        </slotCard>

        <slotCard class="pt-4" :icon="'fas fa-map-marker-alt'" :type="'fourLineMap'" :isLoading="isLoading">
          <span class="block font-weight-bold">Hala III</span>
          <span class="block font-weight-bold">Jasenicka 53</span>
          <span class="block font-weight-bold">Vsetin 666 00</span>
          <span class="block font-weight-bold">Czech Republic</span>
          <!-- add map from back-end -->
        </slotCard>

        <slotCard :icon="'fas fa-tag'" class="pt-4" :type="'oneLine'" :isLoading="isLoading">
          <v-chip color="teal" class="same-line">Hydraulic arm</v-chip>
          <v-chip color="orange" class="same-line">Max 12 t</v-chip>
        </slotCard>

        <slotCard :icon="'far fa-clock'" class="pt-4" :type="'oneLine'" :isLoading="isLoading">
          <v-row>
            <v-subheader>Delivery possible</v-subheader>
            <v-select class="select" :items="items"></v-select>
          </v-row>
        </slotCard>

        <ListItemCardBig v-for="shipment in shipments1PL" :key="shipment.id" class="mt-4" color="#50E898" :resource="{id: shipment.id}">
          <Card1PL :shipment="shipment"/>
        </ListItemCardBig>

        <ListItemCardBig v-for="shipment in shipmentsExpress" :key="shipment.id" class="mt-4" color="#EF476F" :resource="{id: shipment.id}">
          <CardExpress :shipment="shipment"/>
        </ListItemCardBig>
    </div>
</template>

<script>
import slotCard from '@/components/cards/slotCard'
import ListItemCardBig from '@/components/wrld/generic/ListItemCardBig'
import Card1PL from '@/components/cards/Card1PL'
import CardExpress from '@/components/cards/CardExpress'

export default {
  name: 'ExampleCardsView',
  components: {
    slotCard,
    ListItemCardBig,
    Card1PL,
    CardExpress
  },
  data () {
    return {
      isLoading: false,
      items: ['8:00 - 12:00', '12:00 - 5:00', '5:00 - 9:00'],
      shipments1PL: [
        {
          id: '1234',
          arrival: '2019-06-12T06:50:00+02:00',
          departure: '2019-06-12T06:20:00+02:00',
          company: 'Carrier s.r.o.',
          vehicleName: 'Man',
          licencePlate: '1AA 1234',
          volume: 16.3,
          weight: 11.5,
          label: 'Trasa Z',
          status: 'On the way'
        },
        {
          id: '4567',
          arrival: '2019-06-12T06:50:00+02:00',
          departure: '2019-06-12T06:20:00+02:00',
          company: 'Carrier s.r.o.',
          vehicleName: 'Man',
          licencePlate: '1AA 1234',
          volume: 16.3,
          weight: 11.5,
          label: 'Trasa Z',
          status: 'On the way'
        }
      ],
      shipmentsExpress: [
        {
          id: '5678',
          arrival: '2019-06-12T06:50:00+02:00',
          departure: '2019-06-12T06:20:00+02:00',
          company: 'DHL s.r.o.',
          price: 1200,
          quotes: 3,
          label: 'Australie',
          status: 'On the way'
        },
        {
          id: '6789',
          arrival: '2019-06-12T06:50:00+02:00',
          departure: '2019-06-12T06:20:00+02:00',
          company: 'DHL s.r.o.',
          price: 1200,
          quotes: 3,
          label: 'Australie',
          status: 'On the way'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .card-list{
    margin-top: 100px;
    margin-left: 100px;
  }
  span.block {
    display: block;
  }
  .same-line {
    display: inline-block;
  }
  .select {
    width: 90px;
  }
</style>
